//@flow
import * as React from 'react';
import {baseClass} from "../../../../pages/UiKit/newUiKit/utilities/baseClass";
import type {addClasses} from "../../../../services/flowTypes/uiKitFlowTypes";
import './BackButtonIcon.css';

type Props = {
  addClasses?: addClasses
};

const BackButtonIcon = (props: Props) => {
  return (
    <div className={baseClass("BackButtonIcon", props.addClasses)}/>
  );
};

export default BackButtonIcon;